import getCsrfToken from './getCsrfToken';

interface PrepareHeaderProps {
  apiKey: string | undefined;
  method: string;
  sendCsrfToken: boolean;
  customHeaders?: Record<string, string>;
}

const prepareHeaders = async ({
  apiKey,
  method,
  sendCsrfToken,
  customHeaders = {},
}: PrepareHeaderProps): Promise<{ [header: string]: string } | undefined> => {
  const headers = customHeaders;
  headers['Accept'] = 'application/json';
  // We don't send content-type app/json headers for GET requests
  // This results in a flurry of OPTIONS requests that trigger rate-limiting for customers
  if (method !== 'GET') {
    headers['Content-Type'] = 'application/json';
  }

  if (apiKey) {
    headers['Circle-Token'] = apiKey;
  }
  if (method !== 'GET' && sendCsrfToken) {
    const csrfToken = await getCsrfToken();
    headers['x-csrftoken'] = csrfToken;
  }

  return headers;
};

export default prepareHeaders;
